import * as React from 'react';
import Grid from '@mui/material/Unstable_Grid2';
import Typography from '@mui/material/Typography';
import { Spacing } from 'components/Layout';
import { LabeledData } from 'components/Input';
import { formatDollar } from 'helpers/formatters';
import { MapLocation } from 'types/location.type';
import Location from 'application/Models/Location';

interface LocationValuesSectionProps {
    locationData: MapLocation | Location;
}

export const PPValuesSection: React.FC<LocationValuesSectionProps> = ({ locationData }) => {
    return (
        <Grid xs={12}>
            <Spacing height="1.5rem" />
            <Typography variant="h3">Values</Typography>
            <LabeledData title="Building" value={formatDollar(locationData.buildingValue || 0, 0)} />
            <LabeledData title="Rents" value={formatDollar(locationData.biRentalIncomeValue || 0, 0)} />
            <LabeledData title="Personal Property" value={formatDollar(locationData.personalPropertyValue || 0, 0)} />
            <LabeledData title="Other" value={formatDollar(locationData.otherValue || 0, 0)} />
            <LabeledData
                title="TIV"
                value={formatDollar(
                    (locationData.buildingValue || 0) +
                        (locationData.biRentalIncomeValue || 0) +
                        (locationData.personalPropertyValue || 0) +
                        (locationData.otherValue || 0),
                    0
                )}
            />
        </Grid>
    );
};

export const BRValuesSection: React.FC<LocationValuesSectionProps> = ({ locationData }) => {
    // For BR, we need to access different fields from the location data
    const loc = locationData as any;
    const hardCosts = loc.hardCosts || 0;
    const softCosts = loc.softCosts || 0;
    const lossOfGrossEarnings = loc.lossOfGrossEarnings || 0;
    const lossOfRentalIncome = loc.lossOfRentalIncome || 0;
    const tcv = hardCosts + softCosts + lossOfGrossEarnings + lossOfRentalIncome;

    return (
        <Grid xs={12}>
            <Spacing height="1.5rem" />
            <Typography variant="h3">Values</Typography>
            <LabeledData title="Hard Costs" value={formatDollar(hardCosts, 0)} />
            <LabeledData title="Soft Costs" value={formatDollar(softCosts, 0)} />
            <LabeledData title="Loss of Gross Earnings" value={formatDollar(lossOfGrossEarnings, 0)} />
            <LabeledData title="Loss of Rental Income" value={formatDollar(lossOfRentalIncome, 0)} />
            <LabeledData title="TCV" value={formatDollar(tcv, 0)} />
        </Grid>
    );
};
